import ScrollReveal from '../ScrollReveal';
import { t } from '@/data/translations';
import type { Lang } from '@/pages/Index';

const Profile = ({ lang }: { lang: Lang }) => {
  const tr = t(lang).profile;
  return (
    <section id="profile" className="py-24 md:py-32 px-6 md:px-12 lg:px-24">
      <div className="max-w-4xl mx-auto">
        <ScrollReveal>
          <div className="section-divider mb-8" />
        </ScrollReveal>
        
        <ScrollReveal delay={100}>
          <h2 className="text-sm tracking-widest uppercase text-muted-foreground mb-12">
            {tr.sectionTitle}
          </h2>
        </ScrollReveal>
        
        <ScrollReveal delay={200}>
          <p className="text-2xl md:text-3xl lg:text-4xl font-normal leading-relaxed text-foreground text-balance">
            {tr.intro}
          </p>
        </ScrollReveal>

        <ScrollReveal delay={300}>
          <p className="mt-8 text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl">
            {tr.details}
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default Profile;
